import {useState} from 'react';
import {NavLink, Outlet} from 'react-router-dom';
import {Loading} from "../../components/common/Loading";

const AnnouncementList = () => {
    const [workTypeFilter, setWorkTypeFilter] = useState('ALL'); // '', 'H', 'D'
    const [loading, setLoading] = useState(true);

    return (
        <>
            <Loading loading={loading} onClose={() => setLoading(false)}/>
            <main className="container has-tab type_gray">
                {/* 탭 */}
                <section className="tabFixed">
                    <ul className="tab_wrap col3">
                        <li>
                            <NavLink
                                replace
                                to="matching"
                                className={({isActive}) => isActive ? 'active' : ''}
                            >
                                매칭중
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                replace
                                to="ongoing"
                                className={({isActive}) => isActive ? 'active' : ''}
                            >
                                진행중
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                replace
                                to="completed"
                                className={({isActive}) => isActive ? 'active' : ''}
                            >
                                완료
                            </NavLink>
                        </li>
                    </ul>
                </section>

                {/* 필터 */}
                <section>
                    <div className="inner">
                        <div className="filter-wrap">
                        <span className="filter">
                            <input
                                type="radio"
                                id="radio1"
                                name="timetype"
                                checked={workTypeFilter === 'ALL'}
                                onChange={() => setWorkTypeFilter('ALL')}
                            />
                            <label htmlFor="radio1">전체</label>
                        </span>

                            <span className="filter">
                            <input
                                type="radio"
                                id="radio2"
                                name="timetype"
                                checked={workTypeFilter === 'HOURLY'}
                                onChange={() => setWorkTypeFilter('HOURLY')}
                            />
                            <label htmlFor="radio2">시간제</label>
                        </span>

                            <span className="filter">
                            <input
                                type="radio"
                                id="radio3"
                                name="timetype"
                                checked={workTypeFilter === 'DAILY'}
                                onChange={() => setWorkTypeFilter('DAILY')}
                            />
                            <label htmlFor="radio3">종일제</label>
                        </span>
                        </div>
                    </div>
                </section>

                {/* 탭별 내용 */}
                <Outlet context={{workTypeFilter,setLoading}}/>
            </main>
        </>
    );
};

export default AnnouncementList;